<template>
  <div class="search-top">
    <div class="wrap">
      <div class="search-top-tag">
        <div class="search-top-l">
          <div
            v-if="!hasTagData"
            class="search-refresh"
          >
            원하는 태그를 검색해보세요.
          </div>
          <ul
            v-else
            class="ch-search-tag"
          >
            <li v-for="(data, index) in tagDataList" :key="`${index}_${data.text}`">
              <button @click="$emit('click-delete-tag', index)">
                <span class="search-tag-text">{{ data.text }}</span>
                <img
                  :src="require('@/assets/images/search/search-btn-result-tag-delete.svg')"
                  alt="태그 삭제"
                >
              </button>
            </li>
          </ul>
        </div>

        <div class="search-top-r">
          <button
            type="button"
            class="search-refresh"
            @click.prevent="showSearchPopup()"
          >
            태그 재검색
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendEventLogTagReSearch } from '@/common/utils/log.v2.send'

export default {
  name: 'SearchTopTag',
  props: {
    pageType: {
      type: String,
      default: 'broadcast' // 'broadcast' | 'movie'
    },
    tagDataList: {
      type: Array,
      default: null
    }
  },
  computed: {
    hasTagData () {
      return this.tagDataList.length > 0
    }
  },
  methods: {
    // 태그 재검색
    showSearchPopup () {
      sendEventLogTagReSearch({ type: this.pageType })
      this.$events.$emit('showSearchPopupTag', `reTagDetail_${this.pageType}`)
    }
  }
}
</script>
